<script>
    import classnames from 'clsx';
    import I18n from '@js/modules/translations';

    const {
        class: className,
        // Optional [{group, distance, percent}] to show the distance share per surface
        breakdown = []
    } = $props();

    const SURFACE_COLORS = {
        paved: '#616161',
        compacted: '#FF9800',
        gravel: '#FFC107',
        dirt: '#8D6E63',
        natural: '#66BB6A',
        unknown: '#9E9E9E'
    };

    const surfaceGroups = Object.keys(SURFACE_COLORS).map((key) => ({
        key,
        color: SURFACE_COLORS[key]
    }));

    // With a breakdown, list only the surfaces actually present with their share; otherwise the
    // full static legend.
    const items = $derived(
        breakdown.length
            ? breakdown.map((entry) => ({
                key: entry.group,
                color: SURFACE_COLORS[entry.group] || SURFACE_COLORS.unknown,
                percent: entry.percent
            }))
            : surfaceGroups
    );
</script>

<div class={classnames('map-surface-legend', className)}>
    <div class="surface-legend-title">
        {I18n.t('js.maps.toolbar.surface_color.legend_title')}
    </div>

    <div class="surface-legend-items">
        {#each items as group (group.key)}
            <div class="surface-legend-item">
                <span class="surface-legend-color"
                      style="background-color: {group.color}"></span>
                <span class="surface-legend-label">
                    {I18n.t(`js.maps.toolbar.surface_color.types.${group.key}`)}
                    {#if group.percent != null}
                        <span class="surface-legend-percent">{group.percent}%</span>
                    {/if}
                </span>
            </div>
        {/each}
    </div>
</div>
